export interface QuestionRequest {
  question: string;
  session_id?: string;
}

export interface SourceChunk {
  doc_id: number;
  chunk_index: number;
  similarity: number;
  excerpt: string;
}

export interface QASession {
  id: number;
  session_id: string;
  question: string;
  answer: string | null;
  sources: SourceChunk[];
  response_time_ms: number;
  created_at: string;
}

export interface ChatMessage {
  role: 'user' | 'assistant';
  content: string;
  sources?: SourceChunk[];
  session_id?: string;
  timestamp: string;
  isStreaming?: boolean;
}

export interface EntityItem {
  nomor?: string;
  judul?: string;
  jenis?: string;
  nama?: string;
  tipe?: string;
  nilai?: string;
  konteks?: string;
}

export interface DocumentEntities {
  doc_id: number;
  regulations: EntityItem[];
  organizations: EntityItem[];
  people: string[];
  concepts: string[];
  amounts: EntityItem[];
}

export interface ClassificationSuggestion {
  jenis_pnbp: string | null;
  siklus: string | null;
  bentuk: string | null;
  dimensi: string[];
  tags: string[];
  confidence: number;
  alasan: string | null;
  /** False while the Celery AI pipeline is still running for this document. */
  ai_processed?: boolean;
  /** Set true after user has accepted or rejected the suggestion. */
  reviewed?: boolean;
  accepted?: boolean;
  rejection_reason?: string;
}

// ─── Graph ───────────────────────────────────────────────────────────────────

export type NodeType = 'Document' | 'Regulation' | 'Organization' | 'Entity' | 'Tag';
export type RelationshipType = 'REFERENCES' | 'MENTIONS' | 'RELATED_TO' | 'TAGGED_WITH' | 'BELONGS_TO' | 'SUPERSEDES';

export interface GraphNode {
  id: string;
  label: string;
  type: NodeType;
  properties: Record<string, unknown>;
}

export interface GraphEdge {
  from_node: string;
  to_node: string;
  relationship: RelationshipType;
}

export interface GraphData {
  nodes: GraphNode[];
  edges: GraphEdge[];
}

export interface RelatedDocument {
  doc_id: number;
  judul: string;
  kode_jenis: string | null;
  confidentiality: string;
  shared_connections: number;
}

export interface GraphStats {
  nodes: Record<string, number>;
  relationships: Record<string, number>;
}

// Node colors for visualization
export const NODE_COLORS: Record<NodeType, string> = {
  Document:     '#3B82F6', // blue
  Regulation:   '#10B981', // green
  Organization: '#F59E0B', // amber
  Entity:       '#8B5CF6', // purple
  Tag:          '#EC4899', // pink
};
